import React from "react";
import Authenticated from "@/Layouts/Authenticated";
import { useForm } from "@inertiajs/inertia-react";
import PageHeading from "@/Components/PageHeading";
import Label from "@/Components/Label";
import TextInput from "@/Components/TextInput";
import LoadingButton from "@/Components/LoadingButton";
import { Inertia } from "@inertiajs/inertia";

const Alert = () => {
    const breadcrumb = [
        { name: "Dashboard", route: route("dashboard") },
        { name: "Alert", route: null },
    ];

    const { data, setData, errors, post, processing } = useForm({
        value: "",
    });

    function handleSubmit(e) {
        e.preventDefault();
        post(route("fees.alert"));
    }

    function handleCancel(e) {
        e.preventDefault();
        Inertia.visit(route("dashboard"));
    }

    return (
        <div className="py-6">
            <PageHeading heading={"Simple Alert"} breadcrumb={breadcrumb} />
            <div className="mt-8">
                <div className="mx-auto max-w-lg px-4 py-10 pb-12 lg:pb-16">
                    <form onSubmit={handleSubmit}>
                        <div className="space-y-6">
                            <div>
                                <Label
                                    name={"value"}
                                    label={"Minimum Remaining Fee"}
                                />
                                <TextInput
                                    id={"value"}
                                    name={"value"}
                                    onChange={(e) =>
                                        setData("value", e.target.value)
                                    }
                                    errors={errors.value}
                                    value={data.value}
                                    placeholder={"1000"}
                                />
                            </div>
                        </div>
                        <div className="pt-5">
                            <div className="flex justify-end space-x-1">
                                <LoadingButton
                                    type={"button"}
                                    onClick={handleCancel}
                                    loading={processing}
                                    className={"btn-secondary"}
                                >
                                    Cancel
                                </LoadingButton>
                                <LoadingButton
                                    type={"submit"}
                                    loading={processing}
                                    className={"btn-primary"}
                                >
                                    Send Now
                                </LoadingButton>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

Alert.layout = (page) => <Authenticated title={"Fee Alert"} children={page} />;

export default Alert;
